import { useQuery } from '@tanstack/react-query';
import { getPostedInvoicesIdList } from '../Services/InvoiceService';

export const getPreInvoicedIdsRequestParams = (requestParams) => ({
    types: requestParams?.types,
    transactionDateStart: requestParams?.transactionDateStart,
    transactionDateEnd: requestParams?.transactionDateEnd,
    invoiceStartDate: requestParams?.invoiceStartDate,
    invoiceEndDate: requestParams?.invoiceEndDate,
    postStartDate: requestParams?.postStartDate,
    postEndDate: requestParams?.postEndDate,
    invoiceFrequency: requestParams?.invoiceFrequency,
    divisions: requestParams?.divisions,
    bookingIdRangeStart: requestParams?.bookingIdRangeStart,
    bookingIdRangeEnd: requestParams?.bookingIdRangeEnd,
    CorrectionsOnly: requestParams?.CorrectionsOnly,
    IsHighPriority: requestParams?.IsHighPriority,
    SearchWord: requestParams?.SearchWord,
    SearchColumn: requestParams?.SearchColumn,
    isPreInvoice: true,
    invoiceStatus: 'Invoiced',
});

const useGetPostedInvoicesIdList = (params, options) =>
    useQuery({
        queryKey: ['getPostedInvoicesIdList', params],
        queryFn: () => getPostedInvoicesIdList(params),
        ...options,
    });

export default useGetPostedInvoicesIdList;
